import { useState, useEffect, useRef } from 'react'
import getUserTournaments from '../../../../../helpers/userTournaments/loadUserTournaments'

export const useUserTournaments = (id) => {
  const [userTournaments, setUserTournaments] = useState([])
  const [requestSuccess, setRequestSuccess] = useState(false)
  const mountedRef = useRef(true)

  const getTournaments = async () => {
    if (id === undefined || !mountedRef.current) {
      return
    }

    setRequestSuccess(false)

    try {
      const res = await getUserTournaments(id)
      if (mountedRef.current) {
        setUserTournaments(res.tournaments)
      }
    } catch (err) {
      console.log(err)
    } finally {
      if (mountedRef.current) {
        setRequestSuccess(true)
      }
    }
  }

  useEffect(() => {
    getTournaments()

    return () => {
      mountedRef.current = false
    }
  }, [id])

  return {
    userTournaments,
    requestSuccess,
    setRequestSuccess,
    getTournaments,
  }
}
